import { useInsertionEffect, useRef } from 'react';

export function useEventCallback<TArgs extends unknown[], TResult>(
  handler: (...args: TArgs) => TResult,
): (...args: TArgs) => TResult {
  const handlerRef = useRef<typeof handler | null>(null);

  useInsertionEffect(() => {
    handlerRef.current = handler;

    return () => {
      handlerRef.current = null;
    };
  });

  const callbackRef = useRef((...args: TArgs): TResult => {
    const currentHandler = handlerRef.current;

    if (currentHandler == null) {
      throw new Error('useEventCallback callback called before initialization');
    }

    return currentHandler(...args);
  });

  return callbackRef.current;
}
